/*
  This file is part of the project: "Digiziege"
  An app for animal-welfare-oriented goat husbandry and contactless weight estimation.
  GitLab: https://gitlab.rlp.net/proj-wise2526-digiziege/digiziege

  Copyright (c) 2026 Digiziege Team TH-Bingen

  Description:
  Companion app for welfare-oriented goat husbandry featuring contactless weight estimation via camera,
  master data management and health tracking.
  Built as a PWA with a local-first approach to ensure data privacy.

  LICENSE INFORMATION:
  This program is free software: you can redistribute it and/or modify it under the terms of the
  GNU Affero General Public License as published by the Free Software Foundation,
  either version 3 of the License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
  without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
  See the GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License along with this program.
  If not, see <https://www.gnu.org/licenses/>.
*/

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import { i18n } from './i18n/index'
import router from './router'
import { databaseService } from './services/database/database.service.js'
import './style.css'
import './registerServiceWorker'
import { initTheme } from './useTheme.js'

// Load dev tools in development mode
if (import.meta.env.DEV) {
  import('./utils/devtools.js')
}

const app = createApp(App)

//Dark Theme as default (TODO: toggle switch needs to be implemented)
document.documentElement.setAttribute('data-theme', 'dark')

const pinia = createPinia()
app.use(pinia)
app.use(router)
app.use(i18n)

// Initialize database before mounting the app
databaseService.initialize()
  .then(() => {
    console.log(`Database initialized on ${databaseService.getPlatform()} platform`)
    app.mount('#app')
  })
  .catch((error) => {
    console.error('Failed to initialize app:', error)
  })

initTheme()
